import React from "react";
import BusinessSkillChipItem from "./BusinessSkillChipItem";
import CommonChipItem from "./CommonChipItem";
import LanguageSkillChipItem from "./LanguageSkillChipItem";

export default function ChipList(
    {
        chips,
        setChips,
        textBeforeMin,
        textBeforeMax,
        refLanguageLevels,
    } ) {

    const handleRemove = ( chipToRemove ) => {
        setChips( chips.filter( chip => chip !== chipToRemove ) );
    };

    const handleChange = ( chipToUpdate, type, value ) => {
        const updatedChips = chips.map( ( chip ) => (
            chip !== chipToUpdate
                ? chip
                : {
                    ...chip,
                    [ type ]: value
                }
        ) )
        setChips( updatedChips );
    };

    return (
        <>
            <div className="chip-container">
                { chips
                    .filter( chip => chip.type !== 'competence' && chip.type !== 'language' )
                    .map( ( chip, index ) => (
                        <CommonChipItem key={ index } chip={ chip } handleRemove={ handleRemove }/>
                    ) ) }
            </div>
            <div className="competence-container">
                { chips
                    .filter( chip => chip.type === 'competence' )
                    .map( ( chip, index ) => (
                        <BusinessSkillChipItem
                            key={ index }
                            chip={ chip }
                            handleRemove={ handleRemove }
                            handleChange={ handleChange }
                            textBeforeMin={ textBeforeMin }
                            textBeforeMax={ textBeforeMax }
                        />
                    ) ) }
            </div>
            <div className="competence-container">
                { chips
                    .filter( chip => chip.type === 'language' )
                    .map( ( chip, index ) => (
                        <LanguageSkillChipItem
                            key={ index }
                            chip={ chip }
                            handleRemove={ handleRemove }
                            handleChange={ handleChange }
                            textBeforeMin={ textBeforeMin }
                            textBeforeMax={ textBeforeMax }
                            refLanguageLevels={ refLanguageLevels }
                        />
                    ) ) }
            </div>
        </>
    );
}